import PlayButtonSVG from '@/assets/images/svg/glyphs/audio/audio-play.svg';
import { Text } from '@/components/_rebrand/Text';
import cn from 'classnames';
import Image from 'next/image';

export const WatchVideoBtn = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button className={cn('rounded-[64px] flex items-center gap-s bg-white py-xs px-lg ')} onClick={onClick}>
      <Image src={PlayButtonSVG} alt="Play button" width={14} height={14} className="text-black" />{' '}
      <Text type="p2-medium" className="text-black">
        Watch video
      </Text>
    </button>
  );
};
